
import { defineComponent, PropType } from 'vue'

import IssueDetailMixin from '~/mixins/issueDetailMixin'
import ActiveUserMixin from '~/mixins/activeUserMixin'
import { IgnoreCheckIssueActionChoice } from '~/types/types'

export default defineComponent({
  name: 'IgnoreIssueFalsePositive',
  mixins: [IssueDetailMixin, ActiveUserMixin],
  emits: ['close', 'ignore'],
  props: {
    ignoreActionType: {
      type: String as PropType<IgnoreCheckIssueActionChoice>,
      required: true
    },
    checkIssueId: {
      type: String,
      required: true
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    shortcode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isLoading: false,
      comment: ' '
    }
  },
  computed: {
    issueShortcode(): string {
      return this.shortcode ?? this.issue.shortcode ?? this.singleIssue.shortcode
    }
  },
  methods: {
    close(): void {
      this.$emit('close')
    },
    async confirm(): Promise<void> {
      this.isLoading = true
      try {
        const response = await this.ignoreIssueFalsePositive({
          checkIssueId: this.checkIssueId,
          comment: this.comment,
          action: this.ignoreActionType
        })
        if (response.ok) {
          this.$toast.success(
            `Reported the current occurrence of ${this.issueShortcode} as a false-positive.`
          )

          this.$emit('ignore', [this.checkIssueId])
        } else {
          throw new Error('Received a non-ok response for this check')
        }
      } catch (e) {
        this.logErrorForUser(
          e as Error,
          'Ignore Issue',
          {
            method: 'Report false positive',
            shortcode: this.shortcode,
            checkIssueId: this.checkIssueId,
            comment: this.comment
          },
          'Something went wrong while reporting this false positive.'
        )
      } finally {
        this.isLoading = false
      }
    }
  }
})
